import React from 'react';
import SitemapService from '../utils/sitemap';

const RobotsTxt = () => {
  const robotsTxt = SitemapService.generateRobotsTxt();

  return (
    <pre style={{
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      whiteSpace: 'pre-wrap',
      fontSize: '12px'
    }}>
      {robotsTxt}
    </pre>
  );
};

export default RobotsTxt;